import moment from 'moment';
import { isDateOverflow } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';

// CE-3640: regras da tela de Gerenciamento de Fiscalização.
// Mantidas fora do componente para que a tela cuide apenas da apresentação.

export const TIPO_BUSCA_LAVRATURA = "Data da Lavratura";
export const TIPO_BUSCA_EMISSAO_BOLETO = "Data da Emissão do Boleto";

export const COM_INFRACAO = "Com";
export const SEM_INFRACAO = "Sem";

export const opcoesTipoBusca = [
    { value: TIPO_BUSCA_LAVRATURA, label: TIPO_BUSCA_LAVRATURA },
    { value: TIPO_BUSCA_EMISSAO_BOLETO, label: TIPO_BUSCA_EMISSAO_BOLETO },
];

export const opcoesInfracao = [
    { value: COM_INFRACAO, label: "Com Infração" },
    { value: SEM_INFRACAO, label: "Sem Infração" },
];

export function initialStateConsultaGerenciamentoFiscalizacao() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);

    return {
        tipoBusca: TIPO_BUSCA_LAVRATURA,
        infracao: COM_INFRACAO,
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        tipoFiscalizacao_Id: '',
        numeroInfracao: '',
        nome: '',
        documentoIdentificacao: '',
        logradouro: '',
        numero: '',
        bairro: ''
    };
}

// Monta o payload esperado pela API a partir do estado da tela.
export function montarFiltroApi(consulta) {
    return {
        tipoBusca: consulta.tipoBusca,
        dataInicial: consulta.dataInicial || null,
        dataFinal: consulta.dataFinal || null,
        tipoFiscalizacao_Id: Number(consulta.tipoFiscalizacao_Id ?? 0) || 0,
        numeroInfracao: consulta.numeroInfracao,
        nome: consulta.nome,
        // Remove apenas a pontuação da máscara. Letras são preservadas porque
        // existem CNPJ alfanuméricos na base (Ticket 217494).
        documentoIdentificacao: mascaras.cpfcnpjMask(consulta.documentoIdentificacao ?? "", true),
        logradouro: consulta.logradouro,
        numero: consulta.numero,
        bairro: consulta.bairro
    };
}

// Formatação monetária dos indicadores e da lista, em um lugar só.
export function formatarValorIndicador(valor) {
    return "R$ " + Number(valor ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Valida a data no formato do input (YYYY-MM-DD), em modo estrito.
function dataValida(data) {
    return moment(data, "YYYY-MM-DD", true).isValid();
}

// Retorna a mensagem de aviso quando o filtro for inválido, ou null quando estiver válido.
export function validarFiltroGerenciamentoFiscalizacao(consulta) {
    const possuiFiltroAlternativo = !!(
        consulta.nome?.trim() ||
        consulta.numeroInfracao?.trim() ||
        consulta.documentoIdentificacao?.trim()
    );

    if (!possuiFiltroAlternativo && (!consulta.dataInicial || !consulta.dataFinal))
        return "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator, Número da Infração ou CPF/CNPJ.";

    // Data parcial não pode ser aceita em silêncio: a API descarta o período
    // quando falta uma das pontas e devolveria o resultado sem filtro de data.
    if (!consulta.dataInicial !== !consulta.dataFinal)
        return "Informe a data inicial e a data final do período.";

    if (consulta.dataInicial && !dataValida(consulta.dataInicial))
        return "A data inicial informada não é válida. Verifique o valor informado no calendário.";

    if (consulta.dataFinal && !dataValida(consulta.dataFinal))
        return "A data final informada não é válida. Verifique o valor informado no calendário.";

    if (consulta.dataInicial && consulta.dataFinal && moment(consulta.dataFinal).isBefore(moment(consulta.dataInicial)))
        return "A data final não pode ser anterior à data inicial.";

    if (consulta.dataInicial && consulta.dataFinal &&
        isDateOverflow(consulta.dataInicial, consulta.dataFinal, 12, 'months'))
        return "A pesquisa deve ter um período máximo de 12 meses!";

    // O CPF/CNPJ aqui é filtro de busca, não cadastro: aceita documento parcial e
    // alfanumérico, portanto não passa por validação de dígito verificador.

    return null;
}

// Indicadores das consultas Com Infração, na ordem definida na história de usuário.
export function montarIndicadoresComInfracao(dados) {
    if (!dados) return [];

    return [
        { titulo: "Infrações Lavradas", quantidade: dados.infracoesLavradas, cor: "#34495e" },
        { titulo: "Infrações Canceladas", quantidade: dados.infracoesCanceladas, cor: "#7f8c8d" },
        { titulo: "Boletos Emitidos", quantidade: dados.boletosEmitidos, valor: dados.valorBoletosEmitidos, cor: "#2980b9" },
        { titulo: "Boletos Registrados", quantidade: dados.boletosRegistrados, valor: dados.valorBoletosRegistrados, cor: "#3498db" },
        { titulo: "Boletos Cancelados", quantidade: dados.boletosCancelados, valor: dados.valorBoletosCancelados, cor: "#e74c3c" },
        { titulo: "Boletos Liquidados", quantidade: dados.boletosLiquidados, valor: dados.valorBoletosLiquidados, cor: "#2ecc71" },
        { titulo: "Boletos Vencidos", quantidade: dados.boletosVencidos, valor: dados.valorBoletosVencidos, cor: "#f39c12" },
    ];
}

// Indicadores das consultas Sem Infração.
export function montarIndicadoresSemInfracao(dados) {
    if (!dados) return [];

    return [
        { titulo: "Fiscalizações Lavradas", quantidade: dados.fiscalizacoesLavradas, cor: "#34495e" },
        { titulo: "Fiscalizações Canceladas", quantidade: dados.fiscalizacoesCanceladas, cor: "#e74c3c" },
    ];
}
